export default __webpack_public_path__ + "static/media/logo.824b45e4.svg";